class AccountSettings.HashtagBySourceAndTextCollectionUrlProvider extends Backbone.Model
  baseUrl: '/keepcon/hashtag_searches_collection'

  initialize:(source, text)->
    @source = source
    @text = text

  url:(page)->
    @baseUrl + '/' + @source + '/' + page + '/' + @text
